/**
 * Adapts a decimal value into a percentage.
 *
 * @param decimalValue - The decimal value to be converted into a percentage.
 * @returns - The adapted percentage.
 */
export const adaptDecimalValueToPercentage = (decimalValue: number) => {
  return Math.floor(Math.max(0, decimalValue) * 100);
};
